import { TruckIcon } from './TruckIcon';

/**
 * author: Google
 * id A0B91DEA-DB9A-4737-B2F4-26B805B88648
 * name truck
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/truck.svg
 * tags
 * - Transportation + Road 
 */
export const LorryIcon = TruckIcon;
export default LorryIcon